var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filterComments),function(comment){return _c('proposal-comment-item',{key:`pc_${comment.Id}`,attrs:{"commentObj":comment,"comments":_vm.proposal.Comments}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }